var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEarthquake(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8773_613",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 17
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8773_613)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.01634 15.1663C5.86079 15.1663 5.72467 15.1247 5.60801 15.0413C5.49134 14.958 5.41079 14.8441 5.36634 14.6997L3.66634 9.16634H1.99967C1.81079 9.16634 1.65245 9.10245 1.52467 8.97467C1.3969 8.8469 1.33301 8.68856 1.33301 8.49967C1.33301 8.31079 1.3969 8.15245 1.52467 8.02467C1.65245 7.8969 1.81079 7.83301 1.99967 7.83301H4.16634C4.31079 7.83301 4.44134 7.87467 4.55801 7.95801C4.67467 8.04134 4.75523 8.15523 4.79967 8.29967L5.89967 11.883L8.01634 2.36634C8.04967 2.21079 8.12745 2.08301 8.24967 1.98301C8.3719 1.88301 8.51079 1.83301 8.66634 1.83301C8.8219 1.83301 8.96078 1.88023 9.08301 1.97467C9.20523 2.06912 9.28301 2.19412 9.31634 2.34967L10.7663 8.61634L11.6997 5.63301C11.7441 5.48856 11.8247 5.37467 11.9413 5.29134C12.058 5.20801 12.1886 5.16634 12.333 5.16634C12.4775 5.16634 12.6052 5.20523 12.7163 5.28301C12.8275 5.36079 12.9108 5.46634 12.9663 5.59967L13.7997 7.83301H13.9997C14.1886 7.83301 14.3469 7.8969 14.4747 8.02467C14.6025 8.15245 14.6663 8.31079 14.6663 8.49967C14.6663 8.68856 14.6025 8.8469 14.4747 8.97467C14.3469 9.10245 14.1886 9.16634 13.9997 9.16634H13.333C13.1886 9.16634 13.0608 9.12745 12.9497 9.04967C12.8386 8.9719 12.7552 8.86634 12.6997 8.73301L12.383 7.88301L11.2997 11.3663C11.2552 11.5108 11.1719 11.6275 11.0497 11.7163C10.9275 11.8052 10.7886 11.8441 10.633 11.833C10.4775 11.8219 10.3441 11.7691 10.233 11.6747C10.1219 11.5802 10.0497 11.4608 10.0163 11.3163L8.66634 5.51634L6.64967 14.6497C6.61634 14.8052 6.54134 14.9275 6.42467 15.0163C6.30801 15.1052 6.1719 15.1552 6.01634 15.1663Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarthquake);
export default __webpack_public_path__ + "static/media/earthquake.c82a26ef0396d9602ac4ac93e26cd972.svg";
export { ForwardRef as ReactComponent };